import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useHMSActions,
  useHMSStore,
  selectIsConnectedToRoom,
  selectPeers,
  selectCameraStreamByPeerID,
  useHMSNotifications,
  useVideo,
  useAVToggle,
} from "@100mslive/react-sdk";
import {
  LogoutOutlined,
  AudioMutedOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";
import SummaryContainer from "./SummaryContainer";
import { Button, Card, message, Modal } from "antd";
import CommonModal from "../common/commonModal/CommonModal";
import { WS_URL } from "../../config";
import { Scale } from "chart.js";

const VideoCallComponent = () => {
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  console.log(
    isConnected,
    "this is the connection state in the video call component",
  );
  const location = useLocation();

  const token =
    location?.state?.doctorVideoCallToken ||
    sessionStorage.getItem("doctorVideoCallToken");
  const appointmentId =
    location?.state?.appointmentId || sessionStorage.getItem("appointmentId");
  const doctorId =
    location?.state?.doctorId || sessionStorage.getItem("doctorId");
  const slectedRowData =
    location?.state?.rowData || JSON.parse(sessionStorage.getItem("rowData"));

  const videoScreenSize = slectedRowData?.mobile; // to handle the modile styles
  const doctor = sessionStorage.getItem("username");

  return (
    <React.Fragment>
      <JoinRoom
        token={token}
        appointment_Id={appointmentId}
        doctor_Id={doctorId}
        profileVideoSection={false}
        slectedRowData={slectedRowData}
        videoScreenSize={videoScreenSize}
        doctor={doctor}
      />
    </React.Fragment>
  );
};

const JoinRoom = ({
  token,
  doctor_Id,
  appointment_Id,
  slectedRowData,
  videoScreenSize,
  doctor,
}) => {
  const hmsActions = useHMSActions();

  const isConnected = useHMSStore(selectIsConnectedToRoom);

  const peers = useHMSStore(selectPeers);

  const videoTrackPeer1 = useHMSStore(selectCameraStreamByPeerID(peers[1]?.id));
  const isVideoVisiblePeer1 = videoTrackPeer1 && videoTrackPeer1.enabled;

  const [showEndCallModal, setShowEndCallModal] = useState(false);
  const navigate = useNavigate();

  const smallVideoRef = useRef(null);
  const containerRef = useRef(null);

  const { isLocalAudioEnabled, toggleAudio, isLocalVideoEnabled, toggleVideo } =
    useAVToggle();

  useEffect(() => {
    const fetchAndJoinRoom = async () => {
      try {
        await hmsActions.join({ authToken: token, userName: "" });
        message.success("Successfully joined the room!");
      } catch (error) {
        if (error.message.includes("User denied permission")) {
          message.error("Permission to access camera or microphone denied.");
        } else {
          message.error("Failed to join the room. Please try again.");
        }
        console.error("Error joining the room:", error);
      }
    };
    fetchAndJoinRoom();
  }, []);

  const notification = useHMSNotifications();

  if (notification) {
    const { type, data } = notification;

    switch (type) {
      case "RECONNECTING":
        message.info("Reconnecting to servers...");
        break;
      case "RECONNECTED":
        message.success("Reconnected successfully!");
        break;
      case "ERROR":
        if (data?.error?.code === 1003 || data?.error?.code === 4005) {
          message.error(`Error: ${data.error.message}`);
        } else {
          message.error("An error occurred.");
        }
        break;
      case "TRACK_MUTED":
        message.warning("Track has been muted.");
        break;
      case "PEER_JOINED":
        // message.success("A new peer has joined the session.");
        break;
      case "TRACK_DEGRADED":
        message.warning("Track quality has degraded.");
        break;
      case "TRACK_RESTORED":
        // message.success("Track quality has been restored.");
        break;
      case "TRACK_ADDED":
        // message.info("A new track has been added.");
        break;
      case "TRACK_UNMUTED":
        message.success("Track has been unmuted.");
        break;
      case "PEER_LEFT":
        message.info("A peer has left the session.");
        break;
      default:
        // message.info(`Unhandled notification type: ${type}`);
        break;
    }
  }

  const handleEndCallModal = () => {
    setShowEndCallModal(true);
  };

  const handleCancelCallModal = () => {
    setShowEndCallModal(false);
  };

  const cleanupTracks = async () => {
    try {
      const videoElements = document.querySelectorAll("video");
      videoElements.forEach((video) => {
        if (video.srcObject) {
          video.srcObject = null;
        }
      });
      await hmsActions.leave();
    } catch (error) {
      console.error("Error cleaning up tracks:", error);
    }
  };

  const handleLeaveAndRejoin = async () => {
    try {
      await cleanupTracks();
      navigate("/appointments");
      setTimeout(() => {
        window.location.reload();
      }, 50);
    } catch (error) {
      console.error("Error handling Leave click:", error);
    }
  };

  const handleDragStart = (e) => {
    const rect = smallVideoRef?.current.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({
        offsetX: e.clientX - rect.left,
        offsetY: e.clientY - rect.top,
        containerOffsetLeft: containerRect.left,
        containerOffsetTop: containerRect.top,
      }),
    );
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const data = JSON.parse(e.dataTransfer.getData("text/plain"));
    const containerRect = containerRef?.current.getBoundingClientRect();
    const elementRect = smallVideoRef?.current.getBoundingClientRect();

    let newLeft = e.clientX - data.offsetX - containerRect.left;
    let newTop = e.clientY - data.offsetY - containerRect.top;

    newLeft = Math.max(
      0,
      Math.min(newLeft, containerRect.width - elementRect.width),
    );
    newTop = Math.max(
      0,
      Math.min(newTop, containerRect.height - elementRect.height),
    );

    smallVideoRef.current.style.position = "absolute";
    smallVideoRef.current.style.left = `${newLeft}px`;
    smallVideoRef.current.style.top = `${newTop}px`;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  if (!isConnected) {
    return <></>;
  }

  return (
    <>
      <SummaryContainer
        doctorId={doctor_Id}
        appointment_id={appointment_Id}
        hmsActions={hmsActions}
        patientDetails={slectedRowData}
      >
        <div
          className="video-call-container"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          ref={containerRef}
          style={{ position: "relative" }}
        >
          {notification?.type === "PEER_LEFT" ? (
            <div
              className={` ${
                slectedRowData?.tablet_id ? "tablet-present" : "large-video"
              }`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <h2
                style={{
                  fontSize: "24px",
                  width: "100%",
                  height: "100%",
                  marginTop: "20%",
                  marginBottom: "20%",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Meeting Ended
              </h2>
            </div>
          ) : peers?.length > 1 ? (
            <div
              className={` ${
                slectedRowData?.tablet_id ? "tablet-present" : "large-video"
              }`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              {isVideoVisiblePeer1 ? (
                <VideoTile
                  peerId={peers[1]?.id}
                  roleName={peers[1]?.roleName}
                  videoScreenSize={videoScreenSize}
                  peers={peers[1]}
                />
              ) : (
                <p
                  style={{
                    fontSize: "24px",
                    color: "white",
                    backgroundColor: "black",
                    borderRadius: "50%",
                    width: "90px",
                    height: "90px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {slectedRowData?.patient_details?.first_name?.charAt(0)}
                </p>
              )}
            </div>
          ) : (
            <h2
              style={{
                fontSize: "24px",
                width: "100%",
                height: "100%",
                marginTop: "20%",
                marginBottom: "20%",
                color: "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              Meeting End
            </h2>
          )}
          {peers.length > 0 && (
            <div
              id="small-video"
              className="small-video"
              draggable
              onDragStart={handleDragStart}
              ref={smallVideoRef}
            >
              {isLocalVideoEnabled ? (
                <VideoTile
                  peerId={peers[0]?.id}
                  roleName={peers[0]?.roleName}
                  videoScreenSize={videoScreenSize}
                  peers={peers[0]}
                />
              ) : (
                <p
                  style={{
                    fontSize: "20px",
                    color: "white",
                    backgroundColor: "grey",
                    borderRadius: "50%",
                    width: "90px",
                    height: "90px",
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "15%",
                    alignItems: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {doctor?.charAt(0)}
                </p>
              )}
            </div>
          )}
        </div>
        <div className="controls">
          <Button
            className="controlsIcons"
            icon={<LogoutOutlined />}
            onClick={handleEndCallModal}
            danger
          />

          <Button // button to toggle mute
            className="controlsIcons"
            onClick={toggleAudio}
            icon={
              isLocalAudioEnabled ? <AudioOutlined /> : <AudioMutedOutlined />
            }
          />

          <Button // button to toggle video
            className="controlsIcons"
            onClick={toggleVideo}
            icon={
              isLocalVideoEnabled ? (
                <VideoCameraOutlined />
              ) : (
                <VideoCameraAddOutlined />
              )
            }
          />
        </div>
      </SummaryContainer>
      {showEndCallModal && (
        <CommonModal
          title="End Session"
          visible={showEndCallModal}
          onCancel={handleCancelCallModal}
          onConfirm={handleLeaveAndRejoin}
          confirmButtonText="Leave"
          confirmButtonType="primary"
          confirmButtonDanger={true}
        >
          <p>Do you want to end the conversation?</p>
        </CommonModal>
      )}
      {notification?.type === "PEER_LEFT" && (
        <Modal
          title="Meeting Over"
          visible={true} // Ensure this is true when you want the modal to show
          footer={[
            <Button key="leave" danger onClick={handleLeaveAndRejoin}>
              Leave
            </Button>,
          ]}
        >
          <p> Go Back to the Appointments Tab</p>
        </Modal>
      )}
    </>
  );
};

const VideoTile = ({ peerId, videoScreenSize, roleName, peers }) => {
  const hmsActions = useHMSActions();

  const { videoRef } = useVideo({
    trackId: peers.videoTrack,
  });
  return (
    <div className="videoContent">
      <video
        ref={videoRef}
        autoPlay
        muted
        className="video"
        style={
          videoScreenSize
            ? {}
            : {
                objectFit: "cover",
                objectPosition: "center 57%",
                transform: "scale(1)",
                transformOrigin: "center bottom",
              }
        }
      />
    </div>
  );
};

export default VideoCallComponent;
